import { useState } from "react";
import "./Login.css"
import Loader from "../Loader/Loader";
import axios from "axios";
import url from "../../utils";
import Home from "../Home/Home";
import LoginForm from "./LoginForm";


const Login = () => {

    const [validateOtp, setValidateOtp] = useState(0)
    const [loginLoader, setLoginLoader] = useState(false)
    const [consumerId, setConsumerID] = useState("");

    const [validateDeatils, setValidateDetails] = useState(false)
    const [rationCardNumber, setRationCardNumber] = useState("");
    // const [name, setName] = useState(data.name)




    // state to store use data
    const [userData, setUserData] = useState(null)


    const handleRationCardInput = (e) => {
        const value = e.target.value;
        if (/^[a-zA-Z0-9]*$/.test(value)) {
            setRationCardNumber(value);
        }
    }

    // const checkValidRationId=()=>{
    //     if(rationCardNumber.length<9){
    //         alert("Please enter a valid Ration Card Id")
    //         return true;
    //     }
    //     return false;
            
    // }



    const handleLogin = async (e) => {
        try {
            e.preventDefault();
            // if(checkValidRationId()) return;
            setLoginLoader(true);
            const { data } = await
                axios.get(`${url}RationCardSubsidy/GetConsumerDetails?consumerId=${consumerId}`,
                )
            console.log("get consumer details", data)
            setUserData(data)

            // set the session

            sessionStorage.setItem(
                "userSession",
                JSON.stringify({
                    consumerId,
                    rationCardNumber,
                    startTime: Date.now()
                })
            );

            setValidateDetails(true)
        } catch (err) {
            setValidateOtp()
            alert(err.response.data.message)
        } finally {
            setLoginLoader(false)
        }
    }

    const logoutHandler = () => {

        sessionStorage.clear();
        // window.location.href = "#/";

        // console.log("Logout call")
        setConsumerID("")
        setRationCardNumber("")
        setValidateOtp(0)
        setValidateDetails(false)
    }

    return (
        <>
            {
                !validateDeatils ?
                    <div className="login">
                        <h1 className="header">Ration Card Subsidy</h1>

                        <form action="" className="loginForm" onSubmit={handleLogin}>
                            <h3>Consumer ID Verification</h3>

                            {/* <div className="consumerId">
                                <label htmlFor="">Ration Card:</label>
                                <input
                                    type="text"
                                    maxLength={15}
                                    value={rationCardNumber}
                                    name="rationNumber"
                                    placeholder="Please Enter Ration Card"
                                    onChange={handleRationCardInput}
                                />
                            </div> */}

                            <div className="formBody">
                                <LoginForm
                                    setValidateOtp={setValidateOtp}
                                    validateOtp={validateOtp}
                                    consumerId={consumerId}
                                    setConsumerID={setConsumerID}
                                    // checkValidRationId={checkValidRationId}
                                    updateDetailsOtp={false}
                                />
                                {
                                    loginLoader ? <Loader /> :
                                        <button
                                            type="submit"
                                            disabled={loginLoader || validateOtp < 2}
                                            className={`${validateOtp < 2 ? "disabled" : ""}`}
                                        >Get Details</button>
                                }

                                {/* className={`${validateOtp < 2 ? "disabled" : ""}`}  */}
                            </div>
                        </form>
                    </div>
                    : <>
                        <Home consumerData={userData.data} rationId={userData.rationId} logoutHandler={logoutHandler} />
                    </>
            }
        </>
    )
};

export default Login;
